import { Dropdown } from "@nova/component-dropdown"
import { ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectHideAllComments, setHideAllComments } from "plugins/Toolbox/MapComments/CommentSlice"
import { closeMapComment } from "./module"

export const CommentVisibilityMenu = () => {
    const dispatch = useAppDispatch()
    const hideAllComments = useAppSelector(selectHideAllComments)

    return (
        <Dropdown>
            <Dropdown.Trigger as="div">
                <ButtonTertiary
                    LeftIcon={() => <Icons.SmallIcon Icon={Icons.MoreVert} />}
                    className="min-w-[34px] !px-0"
                />
            </Dropdown.Trigger>
            <Dropdown.Menu position="bottom-right" className="min-w-[160px]">
                <Dropdown.ButtonItem
                    onClick={() => {
                        dispatch(setHideAllComments(!hideAllComments))
                        // Hiding leaves comment mode entirely; the
                        // nodes stay hidden until explicitly shown again.
                        if (!hideAllComments) closeMapComment()
                    }}
                >
                    {hideAllComments ? "Show all comments" : "Hide all comments"}
                </Dropdown.ButtonItem>
            </Dropdown.Menu>
        </Dropdown>
    )
}
